exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invitewrapper[data-v-3976ab92]{max-width:650px;margin:0 auto}@media screen and (min-width:641px){.invitewrapper[data-v-3976ab92]{padding-top:27px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3976ab92","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/invite/wrapper/FormInviteWrapper.vue
// module id = 7cd1c664b20f12641513
// module chunks = 22